import { ViewType } from '~/models/shared/types'
import { SearchConfig } from '~/models/search/config'

export const dealsSearchConfig: SearchConfig = {
  settings: {
    isDealsSearch: true,
    viewType: {
      defaultViewTypeMobile: ViewType.GALLERY,
      defaultViewTypeDesktop: ViewType.GALLERY
    },
    searchName: 'deals',
    searchbar: {
      autocompleteEndpoint: '/api/deals/query/',
      usesNuxtLinks: false
    },
    rowsExtraQueryParams: { 'from-deals': true },
    displayAds: true
  },
  rootParams: {
    sort: ['nd'],
    discount: ['2'],
    discountsonly: ['1'],
    category: [20001]
  }
}
